<template>
   <div>

      <div class="head">
         <proHead></proHead>
      </div>

      <div class="proComTwo">
         <div class="box">
            <!-- 左侧内容区 -->
            <div class="le">
               <div class="con wow fadeInUp">
                  <div class="tle">
                     <h3 class="tit-48 montserMedium B-500">{{gudingziduan.tuijian.pone2_1}}</h3>
                     <span class="tit-24">{{gudingziduan.tuijian.pone2_2}}</span>
                  </div>
                  <ul v-loading="loading" :data="lilist">
                     <li v-for="(item, index) in lilist" :key="item.id" @click="handleCheck(index)"
                        :class="active == index ? 'isActive' : ''">
                        <el-radio v-model="radio" :label="index">
                           <i>
                              <svg class="icon" viewBox="0 0 1024 1024" version="1.1" width="18" height="18">
                                 <path
                                    d="M416.832 798.08C400.64 798.08 384.512 791.872 372.16 779.52L119.424 525.76C94.784 500.992 94.784 460.8 119.424 436.032 144.128 411.264 184.128 411.264 208.768 436.032L416.832 644.928 814.4 245.76C839.04 220.928 879.04 220.928 903.744 245.76 928.384 270.528 928.384 310.656 903.744 335.424L461.504 779.52C449.152 791.872 432.96 798.08 416.832 798.08Z"
                                    fill="#E60012"></path>
                              </svg>
                           </i>
                        </el-radio>
                        <div class="con">
                           <div class="icBox">
                              <el-image fit="contain" class="" :src="item.image"
                                 alt="" />
                                 
                           </div>
                           <span class="montserRegular tit-20 mt-60">{{ item.name }}</span>
						   <span  class="montserRegular text-white tit-14 mt-4">{{item.content}}</span>
						  
                        </div>
                     </li>
                  </ul>

                  <!-- 操作按钮 -->
                  <div class="more">
                     <div class="btn1 montserRegular tit-18" @click.stop="$router.back()">{{gudingziduan.xinzengde.Back}}</div>
                     <div class="btn2 montserRegular tit-18" @click="nextPage()">{{gudingziduan.tuijian.pone2_3}}</div>
                  </div>

               </div>

            </div>
            <div class="re">
               <!-- 右侧内容区 -->

               <!-- 步骤条 -->
               <Steps :stpsActive="stpsVal"></Steps>
               <!-- 步骤条 end!!-->


               <div class="bom">
                  <i class="iconfont icon-kongxinwenhao tit-26"></i>
                  <div class="p1 tit-14 montserRegular mt-15 ys-28">{{gudingziduan.tuijian.pone2_4}}</div>
                  <div class="p2 tit-12 mt-10 ys-6">{{gudingziduan.tuijian.pone2_5}}</div>
                  <div class="bomUs" @click="tiaozhuang">{{gudingziduan.tuijian.pone2_6}}</div>
               </div>


            </div>
         </div>


      </div>
   </div>
</template>
<script>
import { string } from 'clipboard';
import proHead from '../../../components/proComSystem/header.vue'
import Steps from '../../../components/proComSystem/steps.vue'
import { getListType } from '@/api/proComSystem.js'


export default {
   components: {
      proHead,
      Steps
   },
   data() {
      return {
         stpsVal: 1,// 步骤条
         active: 0, // 默认选中样式
         radio: 0,// 默认选中类型
         lilist: [],
         loading: true ,//加载
		 gudingziduan: {}
      }
   },
   watch: {
   	    '$store.state.cunyuanyan': {
   	      handler(newValue, oldValue) {
   	        // console.log('语言已更新:', newValue);
   	        this.gudingziduan=this.$store.state.cunyuanyan
   			// console.log(this.gudingziduan,'video')
   	      },
   	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
   	    }
   	},
   
   created() {
	  this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
	  this.gudingziduan=this.$store.state.cunyuanyan
   },
   mounted() {
      new this.$wow.WOW({
         live: false
      }).init()

      getListType().then(res => {
         // console.log(res)
         if (res.code == 200) {
            this.loading = false;
            this.lilist = res.data
			  // 默认选中项
			  let quchuIndex = JSON.parse(localStorage.getItem('onIndex')) || 0
			  this.active = quchuIndex
			  this.radio = quchuIndex
			  // console.log()
	
         }
      })


   },
   computed: {
   },
   methods: {
      //类型单选
      handleCheck(index) {
         // 当前选中项
         this.radio = index
         this.active = index
		 // console.log(this.lilist[this.active])
      },
      nextPage() {
		  this.$cun('deviceList','');
         this.$dakai('/proComThre')
         // 选中项存本地
		 if(this.lilist.length>0){
			this.$cun('powerTypeId',this.lilist[this.radio].id)
		 }else{
			 this.$cun('powerTypeId','')
		 }
         // localStorage.setItem('onIndex', JSON.stringify(this.active))
      },
		tiaozhuang(){
	  	  window.open('https://en.goodwe.com/contact/contact-us')
	 },
   },

}
</script>
<style lang="scss" scoped>
// 主体布局
.proComTwo {
   position: relative;
   background: url('../../../assets/pc/proComSystem/proComTwo-bj.png') no-repeat center;
   background-size: cover;

   .box {
      height: 100vh;
      display: flex;
   }

   .le {
      width: 85%;

   }

   .re {
      width: 15%;
      background: #ececec;
   }
}

// 内容区左侧
.proComTwo .le {
   box-sizing: border-box;
   padding: 0 10%;
   display: flex;
   align-items: center;
   justify-content: center;

   .con {
      width: 100%;
      max-width: 1300px;

      .icBox {height: .6rem; display: flex; align-items: center; justify-content: center;margin-top: 1.3rem;}
      .el-image {height: 100%;}
      .tle {
         text-align: center;

         h3 {}

         span {
            display: block;
            margin-top: .1rem;
         }
      }


      ul {
         margin: 0 -.3rem;
         margin-top: .75rem;
         display: flex;
         justify-content: center;
         flex-wrap: wrap;

         li {
            width: 17%;
            margin: 0 .15rem;
            position: relative;
            padding: 0 .1rem;
            height: 4rem;
            background: linear-gradient(41deg, #ffffff 0%, #dbdbdb 100%);
            border-radius: 0.3rem;
            box-shadow: 0.05rem 0.09rem 0.16rem 0.1rem rgba(0, 0, 0, 0.02);
            display: flex;
            // align-items: center;
            justify-content: center;
            text-align: center;
            overflow: hidden;
            z-index: 1;
            cursor: pointer;


            ::v-deep label {min-width: 20px; min-height: 20px;}

            span {
               display: block;
               color: #333333;
               line-height: 1.5;
               transition: .3s;
            }
         }

         li::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(0deg, #ff785c 0%, #e70a16 100%);
            left: 0;
            top: 0;
            opacity: 0;
            z-index: -1;
            transition: .5s;
         }

         // 选中样式
         li.isActive::after {
            opacity: 1;
         }

         li.isActive ::v-deep .icBox img {
            filter: brightness(100);
            -webkit-filter: brightness(100);
         }

         li.isActive span {
            color: #fff;
         }
      }
   }
}

// 内容区右侧
.proComTwo .re {
   padding: 0 .3rem;
   padding-right: .2rem;
   padding-top: 2rem;
   box-sizing: border-box;
   min-width: 200px;
   .bom {
      position: absolute;
      bottom: 5%;

      i {
         color: #E60012;
      }

      .p1 {
         color: #282828;
      }

      .bomUs {
         cursor: pointer;
         margin-top: .2rem;
         display: inline-block;
         background: #f9fafb;
         border: 1px solid #d1d5dc;
         font-family: "montserRegular";
         border-radius: 50px;
         font-size: 12px;
         padding: .11rem;
         transition: .5s;

         &:hover {
            background: #E60012;
            color: #fff;
            border-color: #E60012;
         }
      }

   }
}

// 底部按钮
.more {
   display: flex;
   justify-content: center;
   margin-top: .9rem;

   >div {
      cursor: pointer;
      transition: .5s;
      border-radius: 50px;
   }

   .btn1 {
      padding: .16rem .48rem;
      border: 1px solid #bebebe;
      color: #333;
      margin-right: .2rem;

      &:hover {
         background: #e70a16;
         border-color: #e70a16;
         color: #fff;
      }
   }

   .btn2 {
      padding: .16rem .35rem;
      background: linear-gradient(-71deg, #e70a16 0%, #ff785c 100%);
      color: #fff;

      &:hover {
         box-shadow: 0 0 .1rem #e70a16;
      }
   }


}


// 单选框样式修改
.el-radio {
   position: absolute;
   right: .2rem;
   top: .23rem;
   opacity: 0;
   background: #ffffff;
   border-radius: 0.07rem;
   margin: 0;
   transition: .5s;
}

.el-radio.is-checked {
   opacity: 1;
}

::v-deep .el-radio__input {
   width: .28rem;
   height: .28rem;
   border: 0;
   opacity: 0;
}

::v-deep .el-radio__input.is-checked {
   background: #fff;
}

::v-deep .el-radio__label {
   position: absolute;
   left: 0;
   width: 100%;
   height: 100%;
   display: flex;
   align-items: center;
   top: 0;
   left: 0;
   padding: 0;
   justify-content: center;
}

// loading样式修改
::v-deep .el-loading-spinner .path {
   stroke: #e70a16 !important;
}


// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width:1024px) {
   .proComTwo .le {padding: 0 .5rem;}
   .proComTwo .le .con ul li {width: 20%;}
}


@media screen and (max-width:767px) {
   .proConHead {background: #f9fafb;}
   .proComTwo {padding: 2rem 0;}
   .proComTwo .le {width: 100%;}
   .proComTwo .re {display: none;}
   .proComTwo .le .con ul {justify-content: space-between; margin: 0;}
   .proComTwo .le .con ul li {width: 42%; margin: .3rem 0;}
}

</style>
